import AutenticacaoService from "@/common/services/autenticacao/autenticacao.service";
import JwtService from "@/common/utils/jwt";
import { interpretarErro } from "@/common/erros/erro.service";
import { TipoErro } from "@/common/erros/catalogo";

export const VERIFICAR_AUTENTICACAO = "verificarAunteticacao";
export const LOGIN = "login";
export const VALIDAR_MFA = "validarMfa";
export const REENVIAR_MFA = "reenviarMfa";
export const LOGOUT = "logout";
export const LIMPAR_DADOS_AUTENTICACAO = "limparDadosAutenticacao";
export const SALVAR_DADOS_AUTENTICACAO = "salvarDadosAuntenticacao";
export const SETAR_USUARIO = "setUsuario";

const state = {
  erros: null,
  user: {},
  usuario : {},
  estaLogado: !!JwtService.buscarToken(),
};

const getters = {
  usuarioLogado(state) {
    return state.usuario;
  },
  estaLogado(state) {
    return state.estaLogado;
  },
  primeiroLogin(state) {
    return state.primeiroLogin;
  },
  ehAdmin(state){
    return state.usuario ? state.usuario.perfil == 'Valorem' : false
  }
};

const actions = {
  async [LOGIN](context, form) {
    return await AutenticacaoService.logar(form).then(async (result) => {
      const dados = result.data.data;

      // Segundo fator pendente: a resposta vem sem token e sem usuario, entao nada
      // pode ser comitado -- do contrario o estado ficaria "logado" sem credencial.
      if (dados && dados.precisaMfa) return dados;

      context.commit(SALVAR_DADOS_AUTENTICACAO, dados);
      return dados;
    });
  },
  async [VALIDAR_MFA](context, { tokenDesafio, codigo, lembrarDispositivo }) {
    return await AutenticacaoService.validarMfa(
      tokenDesafio,
      codigo,
      lembrarDispositivo
    ).then(
      async (result) => {
        const dados = result.data.data;

        if (dados && dados.tokenDispositivo)
          JwtService.salvarTokenDispositivo(dados.tokenDispositivo);

        context.commit(SALVAR_DADOS_AUTENTICACAO, dados);
        return dados;
      }
    );
  },
  async [REENVIAR_MFA](context, tokenDesafio) {
    return await AutenticacaoService.reenviarMfa(tokenDesafio);
  },
  async [LOGOUT](context) {
    context.commit(LIMPAR_DADOS_AUTENTICACAO);
  },
  async [VERIFICAR_AUTENTICACAO](context) {
    if(localStorage.getItem('usuario'))
      context.commit(SETAR_USUARIO, JSON.parse(localStorage.getItem('usuario')));

    const _token = JwtService.buscarToken();
    if (_token === null || _token === undefined) {
      context.commit(LIMPAR_DADOS_AUTENTICACAO);
      return;
    }
    return await AutenticacaoService.validarToken(_token)
      .then(async (result) => {
        let claims = result.data.data.claims;
        localStorage.setItem("claims", JSON.stringify(claims));
      })
      .catch((err) => {
        // Qualquer falha deslogava o usuário -- inclusive uma queda momentânea
        // de rede ou um 502 do gateway, que não dizem nada sobre a validade do
        // token. Token vencido (401) o interceptor do ApiService já encerra; aqui
        // só permissão negada derruba a sessão. O resto preserva o que o usuário
        // estava fazendo (o ApiService já avisou da falha).
        const erro = (err && err.valorem) || interpretarErro(err);
        if (erro.tipo === TipoErro.SESSAO || erro.tipo === TipoErro.PERMISSAO)
          context.commit(LIMPAR_DADOS_AUTENTICACAO);
      });
  },
};

const mutations = {
  [SALVAR_DADOS_AUTENTICACAO](state, usuario) {
    usuario = usuario || {};
    // Blindagem: uma resposta sem "usuario" (ex.: segundo fator pendente) lancaria TypeError
    // na linha do perfil abaixo e deixaria o estado logado sem token.
    const dados = usuario.usuario || {};

    state.estaLogado = !!usuario.accessToken;
    state.usuario = {
      id : dados.id,
      email : dados.email,
      nomeUsuario : dados.nomeUsuario,
      nome : dados.nome,
      foto : dados.foto,
      perfil : dados.perfil
        ? dados.perfil.charAt(0).toUpperCase() + dados.perfil.slice(1)
        : undefined
    };
    state.errors = {};

    localStorage.setItem('usuario', JSON.stringify(state.usuario));

    if (usuario.accessToken) JwtService.salvarToken(usuario.accessToken);
    if (dados.nomeUsuario) JwtService.salvarNome(dados.nomeUsuario);
    if (dados.email) JwtService.salvarEmail(dados.email);
    if (dados.id) JwtService.salvarId(dados.id);
    if (usuario.precisaAlterarSenha) {
      state.primeiroLogin = usuario.precisaAlterarSenha;
      JwtService.salvarPrimeiroLogin(usuario.precisaAlterarSenha)
    }
  },
  [LIMPAR_DADOS_AUTENTICACAO](state) {
    const nextURL = window.location.origin + '/login';
    window.location.href = nextURL;
    window.location.assign(nextURL);
    window.location.replace(nextURL);
    state.estaLogado = false;
    state.usuario = {};
    state.errors = {};
    state.primeiroLogin = false;
    JwtService.excluirToken();
    JwtService.excluirNome();
    JwtService.excluirSobrenome();
    JwtService.excluirEmail();
    JwtService.excluirId();
    localStorage.removeItem('estabelecimentoSelecionado');
    localStorage.removeItem('usuario');
  },
  [SETAR_USUARIO](state, payload){
    localStorage.setItem('usuario', JSON.stringify(payload));
    state.usuario = payload;
  }
};

export default {
  state,
  actions,
  mutations,
  getters,
};
